module.exports = __webpack_public_path__ + "img/holiday-inn-express-lisboa-aeroporto.39f35d39.jpg";